export default [
  {
    text: 'Конструктор',
    // TODO: если необходима сортировка с возрастанием цены и учетом бесплатных модулей,
    //  то нужно передать sort: ['cost', 'freeCost'], P.S. на 04.04.2023 на сервере нет обработки параметра freeCost
    to: { name: 'modules', query: { sort: 'cost' } },
    ico: 'modules',
  },
];



// WEBPACK FOOTER //
// ./src/pages/menu.modules.js